export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 2c.664 0 1.2.536 1.2 1.2V6h-1.6a2 2 0 000 4h1.6v2c0 .664-.536 1.2-1.2 1.2H1.2C.536 13.2 0 12.664 0 12V3.2C0 2.536.536 2 1.2 2H14zm1.6 5.2c.224 0 .4.176.4.4v.8c0 .224-.176.4-.4.4h-2c-.44 0-.8-.36-.8-.8 0-.44.36-.8.8-.8h2z\" fill=\"#1D1D1B\"/>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};